module.exports = __webpack_public_path__ + "static/media/2 (4).d39bbd7c.JPG";